import { useIsFetching } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { useQueueStatus } from "../useTokenQueue";
import { isSubmittingFormAtom } from "../../features/questionnaire/state/isSubmittingFormAtom";

/**
 * Hook to check if any critical operations are currently pending that should block form submission.
 * This includes token queue requests (answers, dependent questions), zipcode validation requests,
 * and active form submissions.
 *
 * @returns {boolean} true if any blocking operations are pending, false otherwise
 */
export function useShouldBlockSubmission(): boolean {
  const isQueueProcessing = useQueueStatus();
  const isValidatingZipcode =
    useIsFetching({ queryKey: ["zipcode-validation"] }) > 0;
  const isSubmittingForm = useAtomValue(isSubmittingFormAtom);

  return isQueueProcessing || isValidatingZipcode || isSubmittingForm;
}
